import { render, staticRenderFns } from "./PromotionsMetric.vue?vue&type=template&id=c9e44e64&scoped=true"
import script from "./PromotionsMetric.vue?vue&type=script&lang=js"
export * from "./PromotionsMetric.vue?vue&type=script&lang=js"
import style0 from "./PromotionsMetric.vue?vue&type=style&index=0&id=c9e44e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e44e64",
  null
  
)

export default component.exports